import { h } from '@stencil/core';

export default (
  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="27" fill="none">
    <path
      d="M10.452 19.403c-4.936 0-8.952-4.016-8.952-8.951C1.5 5.516 5.516 1.5 10.452 1.5c4.935 0 8.951 4.016 8.951 8.952 0 4.935-4.016 8.951-8.951 8.951z"
      stroke="#fff"
      stroke-width="3"
    />
    <path stroke="#fff" stroke-width="3" stroke-linecap="round" d="M17.796 18.402l5.832 6.48" />
  </svg>
);
